import React, { useEffect, useState } from "react";
import { academylist, vehicledashboardcount } from "../../../services/admin";
import { AgGridReact } from "ag-grid-react";
import Select from "react-select";

export default function Vehicledashboard() {
  const [filterProduct, setFilterProduct] = useState([]);
  const [vehfilter, setVehFilter] = useState([]);
  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");
  useEffect(() => {
    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAList(arr);
        }
      }
    });
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listall(arr[0]);
                
              }
            }
           
          }
        }
      });
    }else{
      listall("");
    }
  }, []);

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e)
    } else {
      setAcaID("");
      listall("");
    }
  }

  function listall(aid) {
    setFilterProduct([]);
    setVehFilter([]);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    vehicledashboardcount(temp).then((response) => {
      if (response.status == true) {
        setFilterProduct(response.data.counts);
        setVehFilter(response.data.details);
      }
    })
  }

  const columnDefs = [
    {
      headerName: "Vehicle No",
      field: "vehicle_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Driver Name",
      field: "driver_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Username",
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Type",
      field: "type_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Status",
      field: "active",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: (params) => {
        if (params.value === "Active") {
          return { color: "green", fontWeight: "bold" };
        } else {
          return { color: "red", fontWeight: "bold" };
        }
      }
    },
    {
      headerName: "Academy",
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const cardColors = ['I-st', 'II-st', 'III-st'];

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5"> Vehicle Dashboard</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Vehicle Module</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Vehicle Dashboard
          </li>
        </ol>

      </div>
      <div className="row row-sm">
        {localStorage.getItem("Role") === "1" && (
          <div className="col-xl-6 col-sm-6">
            <div className="mb-3">
              <label className="form-label">
                Select Academy
                <span className="text-danger"> *</span>
              </label>
              <Select
                className="default-select"
                placeholder="Select Academy"
                value={acaid}
                options={alist}
                onChange={handleAcademy}
                isSearchable={true}
                isClearable
                hidden
              />

            </div>
          </div>
        )}
        </div>
      <div className="row row-sm">

        {filterProduct.map((item, index) => {
          const cardColorClass = cardColors[index % 4];
          return (
            <div className="col-xl-3 col-md-4" key={index}>
              <div className="card custom-card">
                <div className={`card-bodyy ${cardColorClass}`}>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="product-content">
                        <h3 className="title">
                          <a >{item.type_name}</a>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                  <div className="col-md-12 col justify-content-center text-center">
                    <h3 className="mb-1 font-weight-bold">
                      {" "}
                      <a >{item.total}</a>{" "}
                      <p className="text-muted ">Total</p>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
      <div className="content-body">
        <div className="container-fluid">
        <div className="card custom-card mg-b-20">
                <div className="card-body">
                  <div className="card-header">
                  <h2 className="main-content-title tx-24 mg-b-5">
                        All Vehicle Detail
                      </h2>
                  </div>
                  <div className="ag-theme-alpine ag-style mt-2">
                    <AgGridReact
                      columnDefs={columnDefs}
                      rowData={vehfilter}
                      pagination="true"
                      paginationPageSize="10"
                      sortingOrder={["asc", "desc"]}
                      suppressDragLeaveHidesColumns={true}
                    />
                  </div>
                </div>
              </div>

        </div>
      </div>
    </div>
  );
}
